import { BlipChat } from 'blip-chat-widget';
import { getHashCode } from 'data/string';
import { ChatFeatures } from './ChatFeatures';
export class ChatService {
    static $inject = ['AccountService2'];
    constructor(AccountService2) {
        this.AccountService2 = AccountService2;
    }
    get built() {
        return this._chatBuilder != undefined;
    }
    get guest() {
        return this._guest;
    }
    async build() {
        let userIdentity;
        let userPassword;
        let userName;
        let userEmail;
        const isBlipChatWidgetEnabled = await ChatFeatures.isBlipChatWidgetEnabled();
        if (!isBlipChatWidgetEnabled) {
            return;
        }
        const account = await this.AccountService2.me();
        if (account) {
            userIdentity = encodeURIComponent(account.email);
            userPassword = getHashCode(account.email);
            userName = account.fullName;
            userEmail = account.email;
        }
        else {
            throw Error('The user is not authenticate');
        }
        const options = {
            window: {
                title: 'BLiP ajuda',
            },
            config: undefined,
        };
        let guest = true;
        if (userIdentity && userPassword) {
            options.config = {
                authType: BlipChat.DEV_AUTH,
                user: {
                    id: userIdentity,
                    password: userPassword,
                    name: userName,
                    email: userEmail,
                },
            };
            guest = false;
        }
        const authConfig = {
            userIdentity,
            userPassword,
            userName,
            userEmail,
            authType: userIdentity && userPassword
                ? BlipChat.DEV_AUTH
                : BlipChat.GUEST_AUTH,
        };
        this._chatBuilder = new BlipChat()
            .withAppKey('YmxpcGFqdWRhMjBtYXN0ZXI6M0UwRTUzNDItMURBNS00MjQ3LTlDMEUtQTkyNTREQzIwMzUw')
            .withButton({ color: '#2CC3D5' })
            .withAuth(authConfig);
        this._chatBuilder.build();
        this._guest = guest;
    }
    destroy() {
        this._chatBuilder.destroy();
        this._chatBuilder = undefined;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
ChatService.$inject = ['AccountService2'];
